import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesGrid from './components/ServicesGrid';
import CTASection from './components/CTASection';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicesHero />
      <ServicesGrid />
      <CTASection />
      <Footer />
    </div>
  );
};

export default ServicesPage;
